export default function getInitState() {
    return {
        searchFormIsOpen: true,
        gridIsOpen: false,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success",
                event_payload: 'export'
            },
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning",
                event_payload: 'backToSearchForm'
            },
        ],
        headerFields: [
            {
                name: "occupationHealthPartnerName",
                label: "Fogl. eü. partner",
                visibility: true,
            },
            {
                name: "occupationHealthPartnerSiteName",
                label: "Fogl. eü. partner telephely",
                visibility: true
            },
            {
                name: "occupationHealthSiteGroupName",
                label: "Munkakör",
                visibility: true
            },
            {
                name: "treatment.startDate",
                label: "Kezelés időpontja",
                slot_name: "startDate_format",
                visibility: true
            },
            {
                name: "patient.name",
                label: "Páciens",
                visibility: true
            },
            {
                name: "patient.dateOfBirth",
                label: "Születési dátum",
                slot_name: "date_format",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Dokumentum létrehozása",
                slot_name: "created_on_format",
                visibility: true
            },
            {
                name: "education",
                label: "Iskolai végzettség",
                visibility: true
            },
            {
                name: "qualification",
                label: "Szakmai képzettség",
                visibility: true
            },
            {
                name: "driverLicense",
                label: "Jogosítvány",
                visibility: true,
                slot_name: "checkFormat44"
            },
            {
                name: "soldierly",
                label: "Katonai szolgálat",
                visibility: true,
                slot_name: "checkFormat45"
            },
            {
                name: "patientHeartSystem",
                label: "Dolgozó Szívérrendszeri",
                visibility: true,
                slot_name: "checkFormat37"
            },
            {
                name: "patientRespiratory",
                label: "Dolgozó Légzőszervi",
                visibility: true,
                slot_name: "checkFormat38"
            },
            {
                name: "patientTumor",
                label: "Dolgozó Daganat",
                visibility: true,
                slot_name: "checkFormat39"
            },
            {
                name: "patientDigestiveOrgans",
                label: "Dolgozó Emésztőszervi",
                visibility: true,
                slot_name: "checkFormat40"
            },
            {
                name: "patientMetabolism",
                label: "Dolgozó Anyagcsere",
                visibility: true,
                slot_name: "checkFormat41"
            },
            {
                name: "patientPsychology",
                label: "Dolgozó Pszich.",
                visibility: true,
                slot_name: "checkFormat42"
            },
            {
                name: "patientOther",
                label: "Dolgozó Egyéb",
                visibility: true,
                slot_name: "checkFormat43"
            },
            {
                name: "fatherHeartSystem",
                label: "Apa Szívérrendszeri",
                visibility: true,
                slot_name: "checkFormat3"
            },
            {
                name: "fatherRespiratory",
                label: "Apa Légzőszervi",
                visibility: true,
                slot_name: "checkFormat4"
            },
            {
                name: "fatherTumor",
                label: "Apa Daganat",
                visibility: true,
                slot_name: "checkFormat5"
            },
            {
                name: "fatherDigestiveOrgans",
                label: "Apa Emésztőszervi",
                visibility: true,
                slot_name: "checkFormat6"
            },
            {
                name: "fatherMetabolism",
                label: "Apa Anyagcsere",
                visibility: true,
                slot_name: "checkFormat7"
            },
            {
                name: "fatherPsychology",
                label: "Apa Pszich.",
                visibility: true,
                slot_name: "checkFormat8"
            },
            {
                name: "fatherOther",
                label: "Apa Egyéb",
                visibility: true,
                slot_name: "checkFormat9"
            },
            {
                name: "motherHeartSystem",
                label: "Anya Szívérrendszeri",
                visibility: true,
                slot_name: "checkFormat10"
            },
            {
                name: "motherRespiratory",
                label: "Anya Légzőszervi",
                visibility: true,
                slot_name: "checkFormat11"
            },
            {
                name: "motherTumor",
                label: "Anya Daganat",
                visibility: true,
                slot_name: "checkFormat12"
            },
            {
                name: "motherDigestiveOrgans",
                label: "Anya Emésztőszervi",
                visibility: true,
                slot_name: "checkFormat13"
            },
            {
                name: "motherMetabolism",
                label: "Anya Anyagcsere",
                visibility: true,
                slot_name: "checkFormat14"
            },
            {
                name: "motherPsychology",
                label: "Anya Pszich.",
                visibility: true,
                slot_name: "checkFormat15"
            },
            {
                name: "motherOther",
                label: "Anya Egyéb",
                visibility: true,
                slot_name: "checkFormat16"
            },
            {
                name: "brotherHeartSystem",
                label: "Testvér Szívérrendszeri",
                visibility: true,
                slot_name: "checkFormat17"
            },
            {
                name: "brotherRespiratory",
                label: "Testvér Légzőszervi",
                visibility: true,
                slot_name: "checkFormat18"
            },
            {
                name: "brotherTumor",
                label: "Testvér Daganat",
                visibility: true,
                slot_name: "checkFormat19"
            },
            {
                name: "brotherDigestiveOrgans",
                label: "Testvér Emésztőszervi",
                visibility: true,
                slot_name: "checkFormat20"
            },
            {
                name: "brotherMetabolism",
                label: "Testvér Anyagcsere",
                visibility: true,
                slot_name: "checkFormat21"
            },
            {
                name: "brotherPsychology",
                label: "Testvér Pszich.",
                visibility: true,
                slot_name: "checkFormat22"
            },
            {
                name: "brotherOther",
                label: "Testvér Egyéb",
                visibility: true,
                slot_name: "checkFormat23"
            },
            {
                name: "smoking",
                label: "Dohányás",
                visibility: true,
                slot_name: "checkFormat24"
            },
            {
                name: "smokingTime",
                label: "Ideje",
                visibility: true
            },
            {
                name: "smokingQuantity",
                label: "Mennyiség (db)",
                visibility: true
            },
            {
                name: "smokingStop",
                label: "Abbahagyta",
                visibility: true
            },
            {
                name: "alcohol",
                label: "Alkohol",
                visibility: true,
                slot_name: "checkFormat25"
            },
            {
                name: "alcoholType",
                label: "Fajtája",
                visibility: true
            },
            {
                name: "alcoholQuantity",
                label: "Mennyiség (liter)",
                visibility: true
            },
            {
                name: "alcoholStop",
                label: "Abbahagyta",
                visibility: true
            },
            {
                name: "sport.text",
                label: "Sportolás",
                visibility: true
            },
            {
                name: "sportType",
                label: "Sportolás típusa",
                visibility: true
            },
            {
                name: "eating.text",
                label: "Étkezési szokás",
                visibility: true
            },
            {
                name: "loadDuration",
                label: "Megterhelés",
                visibility: true
            },
            {
                name: "physicalDuration",
                label: "Fizikai",
                visibility: true
            },
            {
                name: "mentalDuration",
                label: "Mentális",
                visibility: true
            },
            {
                name: "psychicDuration",
                label: "Pszichés",
                visibility: true
            },
            {
                name: "physicalPathogensDuration",
                label: "Fizikai kóroki tényezők",
                visibility: true
            },
            {
                name: "warmthDuration",
                label: "Hő",
                visibility: true
            },
            {
                name: "coldDuration",
                label: "Hideg",
                visibility: true
            },
            {
                name: "noiseDuration",
                label: "Zaj",
                visibility: true
            },
            {
                name: "vibrationHandArmDuration",
                label: "Vibráció: kéz/kar",
                visibility: true
            },
            {
                name: "vibrationWholeBodyDuration",
                label: "Vibráció: egész test",
                visibility: true
            },
            {
                name: "ionizingRadiationDuration",
                label: "Ionizáló sugárzás",
                visibility: true
            },
            {
                name: "nonIonizingRadiationDuration",
                label: "Nem ionizáló sugárzás",
                visibility: true
            },
            {
                name: "biologicalPathogensDuration",
                label: "Biológiai kóroki tényezők",
                visibility: true
            },
            {
                name: "psychosocialPathogenicFactorsDuration",
                label: "Pszichoszociális kóroki tényezók",
                visibility: true
            },
            {
                name: "ergonomicPathologicalFactorsDuration",
                label: "Ergonómiai kóroki tényezők",
                visibility: true
            },
            {
                name: "chemicalPathogensDuration",
                label: "Kémiai kóroki tényezők",
                visibility: true
            },
            {
                name: "arsenicAndItsCompoundsDuration",
                label: "Arzén és vegyületei",
                visibility: true
            },
            {
                name: "benzeneDuration",
                label: "Benzol",
                visibility: true
            },
            {
                name: "aminoCompoundsOfBenzeneDuration",
                label: "Benzol aminovegyületei",
                visibility: true
            },
            {
                name: "nitroCompoundsOfBenzeneDuration",
                label: "Benzol nitrovegyületei",
                visibility: true
            },
            {
                name: "dimethylFormamideDuration",
                label: "Dimetil-fomramid",
                visibility: true
            },
            {
                name: "dioxanDuration",
                label: "Dioxan (dietán-dioxid)",
                visibility: true
            },
            {
                name: "ethyleneDichlorideDuration",
                label: "Etiléndiklorid",
                visibility: true
            },
            {
                name: "ethyleneOxideDuration",
                label: "Etilénoxid",
                visibility: true
            },
            {
                name: "mercuryAndHisCompoundsDuration",
                label: "Higany és vegyületei",
                visibility: true
            },
            {
                name: "halothanDuration",
                label: "Halothan",
                visibility: true
            },
            {
                name: "isocyanateDuration",
                label: "Izocianát",
                visibility: true
            },
            {
                name: "cadmiumAndItsCompoundsDuration",
                label: "Kadmium és vegyületei",
                visibility: true
            },
            {
                name: "magnetDuration",
                label: "Mangán",
                visibility: true
            },
            {
                name: "chromiumAndItsCompoundsDuration",
                label: "Króm és vegyületei",
                visibility: true
            },
            {
                name: "methylBromideDuration",
                label: "Metilbromid",
                visibility: true
            },
            {
                name: "methylChlorideDuration",
                label: "Metilklorid",
                visibility: true
            },
            {
                name: "naAlFluoridesDuration",
                label: "Na-Al-fluorid (kriolit)",
                visibility: true
            },
            {
                name: "nickelDuration",
                label: "Nikkel",
                visibility: true
            },
            {
                name: "nitricOxideDuration",
                label: "Nitrogénoxidul",
                visibility: true
            },
            {
                name: "leadAndItsCompoundsDuration",
                label: "Ólom és vegyületei",
                visibility: true
            },
            {
                name: "plantProtectionProductDuration",
                label: "Növényvédőszer",
                visibility: true
            },
            {
                name: "plantProtectionProductName",
                label: "Növényvédőszer megnevezése",
                visibility: true
            },
            {
                name: "slaveDuration",
                label: "Szelén",
                visibility: true
            },
            {
                name: "coalSulfurDuration",
                label: "Szénkéneg",
                visibility: true
            },
            {
                name: "carbonMonoxideDuration",
                label: "Szénmonoxid",
                visibility: true
            },
            {
                name: "carbonTetrachlorideDuration",
                label: "Széntetraklorid",
                visibility: true
            },
            {
                name: "styreneDuration",
                label: "Szitrol",
                visibility: true
            },
            {
                name: "tetrachloroethaneDuration",
                label: "Tetraklóretán",
                visibility: true
            },
            {
                name: "tolueneDuration",
                label: "Toluol",
                visibility: true
            },
            {
                name: "trichlorethyleneDuration",
                label: "Trikóleritlén",
                visibility: true
            },
            {
                name: "trinitrotolueneDuration",
                label: "Trinitrotoluol (trotyl)",
                visibility: true
            },
            {
                name: "vanadiumDuration",
                label: "Vanádium",
                visibility: true
            },
            {
                name: "vinylChlorideDuration",
                label: "Vinilkorid",
                visibility: true
            },
            {
                name: "porokDuration",
                label: "Porok",
                visibility: true
            },
            {
                name: "asbestosDuration",
                label: "Azbeszt",
                visibility: true
            },
            {
                name: "pulmonaryFibrosisOkPorokDuration",
                label: "Tüdőfibr.-t ok. porok",
                visibility: true
            },
            {
                name: "pulmonaryFibrosisName",
                label: "Tüdőfibr.-t ok. Porok megnev.",
                visibility: true
            },
            {
                name: "glassWoolDuration",
                label: "Üveggyapot",
                visibility: true
            },
            {
                name: "overpressureDuration",
                label: "Túlnyomás",
                visibility: true
            },
            {
                name: "digitalisGlycosidesDuration",
                label: "Digitálisz glikozidok",
                visibility: true
            },
            {
                name: "ethylbenzeneDuration",
                label: "Etil-benzol",
                visibility: true
            },
            {
                name: "phenolDuration",
                label: "Fenol",
                visibility: true
            },
            {
                name: "nhexaneDuration",
                label: "N-hexán",
                visibility: true
            },
            {
                name: "cobaltDuration",
                label: "Kobalt",
                visibility: true
            },
            {
                name: "carcinogenicChemicalsDuration",
                label: "Rákkeltő anyagok (év)",
                visibility: true
            },
            {
                name: "carcinogenicChemicalsText",
                label: "Rákkeltő anyagok",
                visibility: true
            },
            {
                name: "xyleneDuration",
                label: "Xilol",
                visibility: true
            },
            {
                name: "allergicHypersensitivityText",
                label: "Allergiás túlérzékenység",
                visibility: true
            },
            {
                name: "reportedOccupationalDiseasesIncreasedExposureText",
                label: "Bejelentett fogl. betegségek",
                visibility: true
            },
            {
                name: "previousMajorDiseasesSurgeriesAccidentsText",
                label: "Előző betegségek",
                visibility: true
            },
            {
                name: "currentChronicDiseasesText",
                label: "Jelenlegi betegségek",
                visibility: true
            },
            {
                name: "takingMedicationsText",
                label: "Rendszeres gyógyszerszedés",
                visibility: true
            },
            {
                name: "increasedMentalStrain",
                label: "Fokozott pszichés terhelésnek kitett munkavállaló",
                visibility: true,
                slot_name: "checkFormat26"
            },
            {
                name: "screenWorkplace",
                label: "Képernyős munkahelyen dolgozó",
                visibility: true,
                slot_name: "checkFormat27"
            },
            {
                name: "nightShiftWorker",
                label: "Éjszakai műszakban dolgozó",
                visibility: true,
                slot_name: "checkFormat28"
            },
            {
                name: "shiftWorker",
                label: "Váltott műszakban dolgozó",
                visibility: true,
                slot_name: "checkFormat29"
            },
            {
                name: "physicalStrainLight",
                label: "Könnyű fizikai munkát végző",
                visibility: true,
                slot_name: "checkFormat30"
            },
            {
                name: "physicalStrainMedium",
                label: "Közepesen nehéz fizikai munkát végző",
                visibility: true,
                slot_name: "checkFormat31"
            },
            {
                name: "physicalStrainHard",
                label: "Nehéz fizikai munkát végző",
                visibility: true,
                slot_name: "checkFormat32"
            },
            {
                name: "physicalStrainHeatExposure",
                label: "Hőexpozícióban dolgozó",
                visibility: true,
                slot_name: "checkFormat33"
            },
            {
                name: "physicalStrainColdExposure",
                label: "Hideg expozícióban dolgozó",
                visibility: true,
                slot_name: "checkFormat34"
            },
            {
                name: "epidemiologicalJob",
                label: "Járványügyi érdekből kiemelt munkakörben dolgozó",
                visibility: true,
                slot_name: "checkFormat35"
            },
            {
                name: "riskOfAccidentJob",
                label: "Baleseti veszéllyel járó kóroki tényezők hatásának kitett munkavállaló",
                visibility: true,
                slot_name: "checkFormat36"
            },
            {
                name: "bacteriasText",
                label: "Baktériumok",
                visibility: true
            },
            {
                name: "virusesText",
                label: "Vírusok",
                visibility: true
            },
            {
                name: "parasitesText",
                label: "Paraziták",
                visibility: true
            },
            {
                name: "mushroomsText",
                label: "Gombák",
                visibility: true
            },
            {
                name: "operationsText",
                label: "Műtétek",
                visibility: true
            }
        ]
    }
}
